/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentBillItem } from './PaymentBillItem';
import {
    PaymentBillItemFromJSON,
    PaymentBillItemFromJSONTyped,
    PaymentBillItemToJSON,
    PaymentBillItemToJSONTyped,
} from './PaymentBillItem';

/**
 * 
 * @export
 * @interface AdminPaymentItem
 */
export interface AdminPaymentItem {
    /**
     * 支付记录ID
     * @type {number}
     * @memberof AdminPaymentItem
     */
    id?: number;
    /**
     * 支付单编号
     * @type {string}
     * @memberof AdminPaymentItem
     */
    paymentCode?: string;
    /**
     * 信用卡支付商户订单号可读对照（时间戳yyyyMMddHHmm-支付单ID）。仅信用卡支付且有卡付金额时返回，其他支付方式为null；实际传给卡API的ORDER_ID为该支付单ID的AES加密值，本字段仅供展示与对账反查
     * @type {string}
     * @memberof AdminPaymentItem
     */
    cardOrderNo?: string;
    /**
     * 类型：1-支付，2-退款
     * @type {number}
     * @memberof AdminPaymentItem
     */
    paymentType?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof AdminPaymentItem
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof AdminPaymentItem
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof AdminPaymentItem
     */
    userCode?: string;
    /**
     * 账单金额（所有关联账单的totalTransferAmount之和）
     * @type {number}
     * @memberof AdminPaymentItem
     */
    billAmount?: number;
    /**
     * 申请日期
     * @type {string}
     * @memberof AdminPaymentItem
     */
    applyDate?: string;
    /**
     * 优惠券抵扣金额
     * @type {number}
     * @memberof AdminPaymentItem
     */
    couponAmount?: number;
    /**
     * 积分支付
     * @type {number}
     * @memberof AdminPaymentItem
     */
    pointsPay?: number;
    /**
     * 预存款支付金额
     * @type {number}
     * @memberof AdminPaymentItem
     */
    walletPay?: number;
    /**
     * 赠送金支付金额
     * @type {number}
     * @memberof AdminPaymentItem
     */
    bonusPay?: number;
    /**
     * 预存款支付金额（中国钱包），根据关联账单类型判定；非中国账单时为0
     * @type {number}
     * @memberof AdminPaymentItem
     */
    chinaWalletPay?: number;
    /**
     * 预存款支付金额（韩国钱包），根据关联账单类型判定；非韩国账单时为0
     * @type {number}
     * @memberof AdminPaymentItem
     */
    koreaWalletPay?: number;
    /**
     * 银行转账金额（储蓄卡支付）
     * @type {number}
     * @memberof AdminPaymentItem
     */
    bankTransferAmount?: number;
    /**
     * 信用卡支付金额
     * @type {number}
     * @memberof AdminPaymentItem
     */
    creditCardAmount?: number;
    /**
     * 结算方式：1-储蓄卡，2-信用卡，3-预存款支付
     * @type {number}
     * @memberof AdminPaymentItem
     */
    payType?: number;
    /**
     * 汇款人（持卡人姓名）
     * @type {string}
     * @memberof AdminPaymentItem
     */
    cardHolderName?: string;
    /**
     * 实际支付金额
     * @type {number}
     * @memberof AdminPaymentItem
     */
    actualPayAmount?: number;
    /**
     * 结算日期
     * @type {string}
     * @memberof AdminPaymentItem
     */
    updateTime?: string;
    /**
     * 支付对应账单列表
     * @type {Array<PaymentBillItem>}
     * @memberof AdminPaymentItem
     */
    billList?: Array<PaymentBillItem>;
}

/**
 * Check if a given object implements the AdminPaymentItem interface.
 */
export function instanceOfAdminPaymentItem(value: object): value is AdminPaymentItem {
    return true;
}

export function AdminPaymentItemFromJSON(json: any): AdminPaymentItem {
    return AdminPaymentItemFromJSONTyped(json, false);
}

export function AdminPaymentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPaymentItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'paymentCode': json['paymentCode'] == null ? undefined : json['paymentCode'],
        'cardOrderNo': json['cardOrderNo'] == null ? undefined : json['cardOrderNo'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'billAmount': json['billAmount'] == null ? undefined : json['billAmount'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
        'couponAmount': json['couponAmount'] == null ? undefined : json['couponAmount'],
        'pointsPay': json['pointsPay'] == null ? undefined : json['pointsPay'],
        'walletPay': json['walletPay'] == null ? undefined : json['walletPay'],
        'bonusPay': json['bonusPay'] == null ? undefined : json['bonusPay'],
        'chinaWalletPay': json['chinaWalletPay'] == null ? undefined : json['chinaWalletPay'],
        'koreaWalletPay': json['koreaWalletPay'] == null ? undefined : json['koreaWalletPay'],
        'bankTransferAmount': json['bankTransferAmount'] == null ? undefined : json['bankTransferAmount'],
        'creditCardAmount': json['creditCardAmount'] == null ? undefined : json['creditCardAmount'],
        'payType': json['payType'] == null ? undefined : json['payType'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'actualPayAmount': json['actualPayAmount'] == null ? undefined : json['actualPayAmount'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'billList': json['billList'] == null ? undefined : ((json['billList'] as Array<any>).map(PaymentBillItemFromJSON)),
    };
}

export function AdminPaymentItemToJSON(json: any): AdminPaymentItem {
    return AdminPaymentItemToJSONTyped(json, false);
}

export function AdminPaymentItemToJSONTyped(value?: AdminPaymentItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'paymentCode': value['paymentCode'],
        'cardOrderNo': value['cardOrderNo'],
        'paymentType': value['paymentType'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'billAmount': value['billAmount'],
        'applyDate': value['applyDate'],
        'couponAmount': value['couponAmount'],
        'pointsPay': value['pointsPay'],
        'walletPay': value['walletPay'],
        'bonusPay': value['bonusPay'],
        'chinaWalletPay': value['chinaWalletPay'],
        'koreaWalletPay': value['koreaWalletPay'],
        'bankTransferAmount': value['bankTransferAmount'],
        'creditCardAmount': value['creditCardAmount'],
        'payType': value['payType'],
        'cardHolderName': value['cardHolderName'],
        'actualPayAmount': value['actualPayAmount'],
        'updateTime': value['updateTime'],
        'billList': value['billList'] == null ? undefined : ((value['billList'] as Array<any>).map(PaymentBillItemToJSON)),
    };
}

